var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"height":_vm.tableHeight,"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading},on:{"on-row-click":_vm.onRowClick}})}
var staticRenderFns = []

export { render, staticRenderFns }